import { BaseLookupField } from "pages/deal/components/LookupField";
import { useLedgerAccountsLookupQuery } from "queries/useLedgerAccount";
import { FieldComponentProps } from "types/standardForm";

export function LedgerAccountLookupField(
  props: FieldComponentProps & {
    showLabel?: boolean;
  }
) {
  const { data = [], isLoading, refetch } = useLedgerAccountsLookupQuery();

  return (
    <BaseLookupField
      {...props}
      dataOptions={data}
      dataIsLoading={isLoading}
      refetch={refetch}
    />
  );
}
